import { SelectSingleInput } from "../../Inputs/SelectInput";
import React from "react";

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

const HighFrequencyProductsSelector = (props: IProps) => {
  const { value, onChange } = props;

  return (
    <SelectSingleInput
      items={['1', '0']}
      itemToOption={value => ({
        value: value,
        label: value === '1' ? 'Yes' : 'No'
      })}
      onChange={value => {
        onChange(value === '1')
      }}
      selectedItem={value ? '1' : '0'}
      name="high-frequency-products"
      isSearchable={false}
      isClearable={false}
    />
  )
}

export default HighFrequencyProductsSelector;
